module.exports = __webpack_public_path__ + "assets/img/marriage-bg3.149680ee.png";